<div class="ki-table-result">
  <p-table [value]="table" class="mt-2" showGridlines>
    <ng-template #body let-row let-ri="rowIndex">
      <tr>
        @for (cell of row; track $index) {
          @if (cell.isHeader) {
            <td class="bg-gray-100 font-bold" style="text-align: center !important;">
              <span class="whitespace-pre">{{ cell.value }}</span>
            </td>
          } @else if (cell.isEditable) {
            <td class="text-primary" style="text-align: center !important;">
              {{ userAnswers[ri]?.[$index] || '' }}
            </td>
          } @else {
            <td style="text-align: center !important;">
              {{ cell.value }}
            </td>
          }
        }
        <td class="ki-score-cell" style="text-align: center !important;">
          {{ kiTable[ri]?.score ?? '' }}
        </td>
        <td class="ki-comment-cell">
          {{ kiTable[ri]?.comment ?? '' }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  @if (kiReasoning) {
    <div class="mt-3">
      <span class="font-semibold">Begründung:</span>
      <div class="mt-1 ki-reasoning-box">{{ kiReasoning }}</div>
    </div>
  }
</div>
